import styled from 'styled-components';
import { Icon, StackPanel, Typography } from '@agilepoint/wat-react-ux';

export const Label = styled(Typography.Medium) <{ $isActive: boolean, $checked: boolean }>`
  color: ${({ $isActive, $checked, theme: { mobileAppAccelerator: { semanticColors }, semantics } }) => {
        const uncheckedStyles = $isActive ? semanticColors.wizard.activeStepColor : semanticColors.grayVariant2;
        return $checked ? semantics.palette.neutralPrimary : uncheckedStyles;
    }};  
`;

export const CompletedStepIcon = styled(Icon) <{ $checked: boolean }>`
    fill: ${({ theme, $checked }) => $checked && theme.mobileAppAccelerator.semanticColors.wizard.checkedStepColor};
`;

export const HeaderWrapper = styled(StackPanel)`
    padding: 0 16px;
    box-sizing: border-box;
`;
